import { render, staticRenderFns } from "./ot-phone-number-field-wrapper.vue?vue&type=template&id=e837240a&scoped=true&"
import script from "./ot-phone-number-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-phone-number-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-phone-number-field-wrapper.vue?vue&type=style&index=0&id=e837240a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e837240a",
  null
  
)

export default component.exports